import countries from 'i18n-iso-countries';
import localeFr from 'i18n-iso-countries/langs/fr.json';

countries.registerLocale(localeFr);

export default countries;
